// Build-time bundling of the repo user guide + runbooks into the SPA.
//
// `import.meta.glob(..., { query: '?raw', eager: true })` inlines every matched
// markdown file's text into the bundle at build time (#150/#151). The docs live
// at the repo root under `docs/`, four levels up from this module. Rebuilding
// the SPA re-reads whatever is on disk, so a docs change lands in the portal on
// the next deploy with no runtime fetch or sync service.

import { buildDocs, type HelpDoc } from './docs';

const guideFiles = import.meta.glob('../../../../docs/user-guide/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

const runbookFiles = import.meta.glob('../../../../docs/runbooks/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

// `_style.md` is an authoring style guide for the doc set itself, not user-
// facing help content — exclude it. `README.md` is the role-keyed index, which
// duplicates our own section list; drop it too so the nav isn't redundant.
const GUIDE_EXCLUDE = new Set(['_style', 'README']);

export const guideDocs: HelpDoc[] = buildDocs(guideFiles, 'guide').filter(
  (d) => !GUIDE_EXCLUDE.has(d.id),
);

export const runbookDocs: HelpDoc[] = buildDocs(runbookFiles, 'runbook');
